import React from 'react';
import SvgWrapper from './SvgWrapper.js';

export default function Plus(props) {
  return (
    <SvgWrapper angle={props.angle} scale={props.scale} left={props.left} top={props.top}>
      <svg width="76" height="73" viewBox="0 0 76 73" fill="none" 
        xmlns="http://www.w3.org/2000/svg">
        <path d="M25.833 6V45.6667" stroke={props.color || "#34A853"} stroke-width={props.thick || "11"} stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6 25.8334H45.6667" stroke={props.color || "#34A853"} stroke-width={props.thick || "11"} stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </SvgWrapper>
  )
}
